import { Grid } from "@material-ui/core";
import React from "react";
import {
  DataCard,
  DataCardListItem,
  DataCardMultilineItem,
} from "@ofqual/portal-components/components/DataCard/DataCard";
import { TeachingExpertiseModel } from "../../domain/TeachingExpertiseModel";
import { RefSubjectModel } from "../../domain/RefSubjectModel";
import { ExpertiseType, SubjectModel } from "../../domain/SubjectModel";
import { useDisplaySubjects } from "../../hooks/useRefSubjects";

export const TeachingExpertise: React.FC<{
  dialogTitle: string;
  teachingExpertise: TeachingExpertiseModel;
  subjects: SubjectModel[];
  refSubjects: RefSubjectModel[];
}> = ({ teachingExpertise, subjects, refSubjects }) => {
  const {
    displaySubjects
  } = useDisplaySubjects(subjects, refSubjects, ExpertiseType.Teaching);

  const displayTeachingExpertise = (
    teachingExpertise: TeachingExpertiseModel
  ) => {
    const items: (DataCardMultilineItem | DataCardListItem)[] = [
      {
        itemType: "MULTILINE",
        key:
          "Are you currently working in a teaching, lecturing or training role?",
        value: teachingExpertise?.isTeachingLecturingOrTraining ? "Yes" : "No",
      },
    ];

    if (subjects.some((s) => s.expertiseType & ExpertiseType.Teaching)) {
      items.unshift({
        itemType: "LIST",
        key: "Subjects",
        value: displaySubjects.filter((s) => s !== ""),
      });
    }

    if (teachingExpertise?.teachingOrLecturingExperience) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in teaching or lecturing",
        value: teachingExpertise.teachingOrLecturingExperience,
      });
    }

    if (teachingExpertise?.trainingExperience) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience working in training",
        value: teachingExpertise.trainingExperience,
      });
    }

    if (teachingExpertise?.educationalManagementExperience) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in educational management",
        value: teachingExpertise.educationalManagementExperience,
      });
    }

    if (teachingExpertise?.teacherTrainingExperience) {
      items.push({
        itemType: "MULTILINE",
        key: "Provide details of your experience in teacher training",
        value: teachingExpertise.teacherTrainingExperience,
      });
    }

    if (teachingExpertise?.teachingOrLecturingExperienceFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key:
          "Further evidence in your experience in teaching or lecturing",
        value: teachingExpertise.teachingOrLecturingExperienceFurtherEvidence,
      });
    }

    if (teachingExpertise?.trainingExperienceFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key:
          "Further evidence in your experience in training",
        value: teachingExpertise.trainingExperienceFurtherEvidence,
      });
    }


    if (teachingExpertise?.educationalManagementExperienceFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key:
          "Further evidence in your experience in education management",
        value: teachingExpertise.educationalManagementExperienceFurtherEvidence,
      });
    }

    if (teachingExpertise?.teacherTrainingExperienceExperienceFurtherEvidence) {
      items.push({
        itemType: "MULTILINE",
        key: "Further in your experience in teacher training",
        value: teachingExpertise.teacherTrainingExperienceExperienceFurtherEvidence,
      });
    }

    return items;
  };

  return (
    <>
      <div style={{ overflowWrap: 'break-word' }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <DataCard
              showHeading={false}
              heading={null}
              items={displayTeachingExpertise(teachingExpertise)}
              hasAction={false}
              actionDescription={null}
              actionButtonText={null}
              actionFunction={null}
              headingComponent={"h1"}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
